import PRESCRIPTIONS from './ticket/prescription';
import TASKS from './ticket/task';

/**Ticket status */
const REFUSED = -10;
const FAILED = -5;
const CREATED = 0;
const PROCESSED = 10;
const PENDING = 15;
const INVITE = 16;
const PAYED = 20;
const UNVERIFIED = 25;
const REJECTED = 30;
const WAITING = 40;
const ACTIVE = 50;
const CLOSED = 100;
const ARCHIVED = 110;

/**Ticket types */
const TICKET = 'ticket';
const FOLLOWUP = 'followup';
const TYPE_INVITE = 'invite';

export default {
	STATUS: {
		REFUSED,
		FAILED,
		CREATED,
		PROCESSED,
		PENDING,
		INVITE,
		PAYED,
		UNVERIFIED,
		REJECTED,
		WAITING,
		ACTIVE,
		CLOSED,
		ARCHIVED,
	},
	TYPES: {
		TICKET,
		FOLLOWUP,
		TYPE_INVITE,
	},
	SCOPES: {
		NAVIGATION: {
			OVERVIEW: 'tickets.navigation.overview',
			MESSAGES: 'tickets.navigation.messages',
			VIDEO: 'tickets.navigation.video',
			MEETINGS: 'tickets.navigation.meetings',
			ALERTS: 'tickets.navigation.alerts',
			QUESTIONNAIRES: 'tickets.navigation.questionnaires',
			SHARE_SELFCARE: 'tickets.navigation.share_selfcare',
			FILES: 'tickets.navigation.files',
			CERTIFICATES: 'tickets.navigation.certificates',
			PRESCRIPTIONS: 'tickets.navigation.prescriptions',
			FOLLOWUPS: 'tickets.navigation.followups',
			APPOINTMENTS: 'tickets.navigation.appointments',
			REJECT: 'tickets.navigation.reject',
			NOTES: 'tickets.navigation.notes',
			REFERENCE: 'tickets.navigation.reference',
			DIAGNOSES: 'tickets.navigation.diagnoses',
			VERIFY: 'tickets.navigation.verify',
			REACTIVATE: 'tickets.navigation.reactivate',
			SURVEYS: 'tickets.navigation.surveys',
      ASSIGN_QUESTIONNAIRE: 'tickets.navigation.assign_questionnaire',
		},
		OVERVIEW: {
			CARETEAM: 'tickets.overview.careteam',
			HISTORY: 'tickets.overview.history',
			ALERTS: 'tickets.overview.alerts',
			QUESTIONNAIRES: 'tickets.overview.questionnaires',
			SURVEYS: 'tickets.overview.surveys',
			SURVEYS_HISTORY: 'tickets.overview.surveys.history',
			APPOINTMENTS: 'tickets.overview.appointments',
			FOLLOWUPS: 'tickets.overview.followups',
			CERTIFICATES: 'tickets.overview.certificates',
			PRESCRIPTIONS: 'tickets.overview.prescriptions',
			DIAGNOSES: 'tickets.overview.diagnoses',
			NOTES: 'tickets.overview.notes',
			MEETINGS: 'tickets.overview.meetings',
			FILES: 'tickets.overview.files',
			TASKS: 'tickets.overview.tasks',
			CASE_ID: 'ticket.overview.case_id',
			PRESCRIPTIONS_PENDING: 'tickets.overview.prescriptions_pending',
			PRESCRIPTIONS_REFUSED: 'tickets.overview.prescriptions_refused',
			PRESCRIPTIONS_VALIDATED: 'tickets.overview.prescriptions_validated',
			PATIENT_GENDER: 'tickets.overview.patient_gender',
		},
		TAGS: {
			TAGS: 'tickets.tags',
			TAGS_EDIT: 'tickets.tags_edit',
		},
		MESSAGES: {
			WRITE: 'tickets.messages.write',
			UPLOAD_FILE: 'tickets.messages.upload_file',
			MENTION: 'tickets.messages.mention',
			links: 'tickets.messages.links',
      ASSIGN_SCHEDUELER: 'tickets.messages.assign_scheduler',
      SHARE_ARTICLE: 'tickets.messages.share_article',
      SHARE_TEMPLATE: 'tickets.messages.share_template',
      ASSIGN_QUESTIONNAIRE: 'tickets.messages.assign_questionnaire',
      SCHEDULER_CHAT_MESSAGE: 'tickets.messages.scheduler_message',
		},
		MANAGE: {
			SAVE: 'tickets.manage.save',
			CLOSE: 'tickets.manage.close',
			SUMMARY: 'tickets.manage.summary',
			ACCESS: 'tickets.manage.access',
			VIEW: 'tickets.manage.view',
			VERIFY: 'tickets.manage.verify',
			DELETE: {
				PRESCRIPTIONS: 'tickets.manage.delete.prescriptions',
        SURVEYS: 'tickets.manage.delete.surveys',
        OWN: {
          APPOINTMENTS: 'tickets.manage.delete.own.appointments',
        },
        ALL: {
          APPOINTMENTS: 'tickets.manage.delete.all.appointments'
        },
			},
			VALIDATE: {
				PRESCRIPTIONS: 'tickets.manage.validate.prescriptions',
			},
			EDIT: {
				OWN: {
					APPOINTMENTS: 'tickets.manage.edit.own.appointments',
				},
				ALL: {
					APPOINTMENTS: 'tickets.manage.edit.all.appointments',
				},
			},
		},
		QUESTIONNAIRES: {
			ANSWER: 'tickets.questionnaires.answer',
			DETAILS: 'tickets.questionnaires.details',
			DISPLAY: 'tickets.questionnaires.display',
			STATISTICS: 'tickets.questionnaires.statistics',
		},
		CARETEAM: {
			ADD: 'tickets.careteam.add',
			REMOVE: 'tickets.careteam.remove',
			ADD_EXTERNAL: 'tickets.careteam.add_external',
			EDIT: 'tickets.careteam.edit',
			ASSIGN_RESPONSIBLE: 'tickets.careteam.assign_responsible',
			CHANGE_RESPONSIBLE: 'tickets.careteam.change_responsible',
			DETAILS: 'tickets.careteam.details',
		},
		VIDEO: {
			START_VIDEO_SESSION: 'ticket.video.start_video_session',
		},
		FILES: {
			NOTIFY_DOWNLOAD: 'ticket.files.notify_download',
			DETAILS: 'tickets.files.details',
			MARKDOWNLOAD: 'tickets.files.markdownload',
			AUTHOR_DELETE: 'tickets.files.author_delete',
			DELETE: 'tickets.files.delete',
		},
	},
	PRESCRIPTIONS,
	TASKS,
};
